document.addEventListener("DOMContentLoaded", function () {
  const bodyTab = document.getElementById("measureBodyBtn");
  const garmentTab = document.getElementById("measureGarmentBtn");
  const cmBtn = document.getElementById("cmBtn");
  const inBtn = document.getElementById("inBtn");
  const cmGBtn = document.getElementById("cmGBtn");
  const inGBtn = document.getElementById("inGBtn");
  const applyBtnBody = document.getElementById("applyBtnBody");
  const applyBtnGarments = document.getElementById("applyBtnGarments");
  const continueShoppingBtn = document.getElementById("continueShoppingBtn");

  
  const popup = document.getElementById("measurementPopup");
  const openBtn = document.getElementById("openPopupBtn");
  const closeBtn = document.getElementById("closePopupBtn");

  [cmBtn, inBtn, cmGBtn, inGBtn].forEach(btn => {
    btn.addEventListener("click", function () {
      document.querySelectorAll(".unit").forEach(u => u.classList.remove("active"));
      this.classList.add("active");
    });
  });

  const numberInputs = document.querySelectorAll('.row input[type="number"]');
  
  numberInputs.forEach(input => {
    input.addEventListener('input', () => {
      input.value = input.value.replace(/[^0-9.]/g, '');
      const maxLength = input.getAttribute('maxlength');
      if (maxLength && input.value.length > maxLength) {
        input.value = input.value.slice(0, maxLength);
      }
    });
  });


  const bodyBox = document.getElementById("measureBodyBox");
  const garmentBox = document.getElementById("measureGarmentBox");

  function switchTab(activeTab) {
    document.querySelectorAll(".tab").forEach(tab => tab.classList.remove("active"));
    bodyBox.style.display = "none";
    garmentBox.style.display = "none";
    activeTab.classList.add("active");
    if (activeTab.id === "measureBodyBtn") {
      bodyBox.style.display = "block";
    } else if (activeTab.id === "measureGarmentBtn") {
      garmentBox.style.display = "block";
    }
  }

  bodyTab.addEventListener("click", () => switchTab(bodyTab));
  garmentTab.addEventListener("click", () => switchTab(garmentTab));
  switchTab(bodyTab);

  document.addEventListener("click", function (e) {
    if (e.target && e.target.id === "applyBtnBody") {
      window.location.href = "/pages/measure-success";
    }

    // if (e.target && e.target.id === "applyBtnGarments") {
    //   window.location.href = "/pages/measure-success";
    // }

    if (e.target && e.target.id === "continueShoppingBtn") {
      e.preventDefault();
      window.location.href = "/";
    }

    if (e.target && e.target.id === "openPopupBtn") {
       e.preventDefault();
    popup.classList.remove("hidden");
    }

    if (e.target && e.target.id === "closePopupBtn") {
       popup.classList.add("hidden");
    }

    if (e.target === popup) closePopup();
    
  });

  function openPopup() {
    popup.classList.add('active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; // prevent background scroll
  }
  function closePopup() {
    popup.classList.remove('active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.location.href = "/pages/measure-success";
  }

  if (applyBtnGarments) applyBtnGarments.addEventListener('click', function(e){ e.preventDefault(); openPopup(); });
  if (openBtn) openBtn.addEventListener('click', function(e){ e.preventDefault(); openPopup(); });
  if (closeBtn) closeBtn.addEventListener('click', function(){ closePopup(); });
  if (continueShoppingBtn) applyBtnGarments.addEventListener('click', function(e){openPopup();});
  
});

custom-measurement.js